import { Component, Inject, Prop, Ref, Vue, Watch } from 'vue-property-decorator';

import AlertaComponent from '@/components/alerta/alerta.component';
import * as Constants from '@/constants';
import router from '@/router';
import AlertService from '@/shared/alert/alert.service';
import { DATE_TIME_FORMAT_CUSTOM } from '@/shared/date/filters';
import EntityFactory from '@/shared/entity-commons/entity.factory';
import { ReniecytApi } from '@/shared/openapi-reniecyt-client/api';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

const VALIDATIONS = function () {
  return {};
};
@Component({
  validations: VALIDATIONS,
  computed: {
    ...mapGetters(['account']),
  },
})
export default class ConsultaSolicitudesComponent extends Vue {
  @Inject('reniecytApi') private reniecytApi: () => ReniecytApi;
  @Inject('alertService') private alertService: () => AlertService;

  public account;
  /**
   * alerta
   */
  @Ref()
  alerta!: AlertaComponent;

  //cantidad de registros por pagina en tabla
  @Prop({ default: 10 })
  public recordsPage: number;

  public solicitudes: Array<any> = [];
  public removeIndex = null;

  //variables paginacion tabla
  public currentPage = 1;
  public sortBy = 'orden';
  public sortDesc = false;
  public sortDirection = 'asc';

  public validSolictud = false;
  public comentario = '';

  public showOverlay = false;

  @Watch('account.cvu', { immediate: true })
  handler(value) {
    if (value) {
      this.showOverlay = true;
      EntityFactory.eliminaVariablesStore();
      this.consultaSolicitudes();
    }
  }

  public fieldsRegistros = [
    {
      key: 'numeroReniecyt',
      label: this.$t('consulta-solicitudes.table.noReniecyt').toString(),
      class: 'text-center',
      sortable: true,
      sortDirection: 'asc',
    },
    {
      key: 'empresaInstitucion',
      label: this.$t('consulta-solicitudes.table.empresaInst').toString(),
      class: 'text-center',
      sortable: true,
    },
    {
      key: 'fechaCreacion',
      label: this.$t('consulta-solicitudes.table.fechaRegistro').toString(),
      class: 'text-center',
      sortable: true,
      formatter: value => {
        if (!value) return null;
        return dayjs(value).format(DATE_TIME_FORMAT_CUSTOM);
      },
    },
    { key: 'estatus', label: this.$t('consulta-solicitudes.table.estatus').toString(), class: 'text-center', sortable: true },
    { key: 'incumplimiento', label: this.$t('consulta-solicitudes.table.incumplimiento').toString(), class: 'text-center', sortable: true },
    { key: 'acciones', label: this.$t('consulta-solicitudes.table.acciones').toString(), class: 'text-center tbl-acciones' },
  ];

  public solicitud: {
    idRegistro?: any;
    numeroReniecyt?: any;
    empresaInstitucion?: any;
    fechaCreacion?: any;
    estatus?: any;
    incumplimiento?: any;
    tipoPersona?: any;
  } = {
    idRegistro: null,
    numeroReniecyt: null,
    empresaInstitucion: null,
    fechaCreacion: null,
    estatus: null,
    incumplimiento: null,
    tipoPersona: null,
  };

  private consultaSolicitudes() {
    this.reniecytApi()
      .getRegistroSolicitudes(this.account.cvu)
      .then(res => {
        this.solicitudes = res.data;
        this.validSolictud = true;

        if (!this.solicitudes.length) {
          this.alertService().showWarning(this, this.$t('consulta-solicitudes.alert.empty').toString());
          this.$router.push({ name: 'NuevaSolicitud' });
        }
        this.showOverlay = false;
      })
      .catch(err => {
        if (err?.response?.data?.detail) {
          this.alertService().showError(this, err.response.data.detail);
        } else {
          this.alertService().showError(this, this.$t('error.internalServerError').toString());
        }
        this.showOverlay = false;
      });
  }

  public prepareSolicitud(item, id) {
    localStorage.setItem('idRegistro', window.btoa(id));
    if (item.reseteado) {
      this.redireccionaEdionRegistro();
      return;
    }

    localStorage.setItem('estatusRegistroPadre', window.btoa(item.estatus));
    localStorage.setItem('tipoPersona', window.btoa(item.tipoPersona));

    if (item.tipoPersona == Constants.PER_MORAL) {
      router.push({ name: 'SolicitudMoral' }).catch(() => {});
    } else if (item.tipoPersona == Constants.PER_FISICA) {
      EntityFactory.guardarIsRepresentante(false);
      localStorage.setItem('idPersonaPadre', window.btoa(EntityFactory.obtenerIdPersona()));
      localStorage.setItem('idPersona', window.btoa(item.idPersona));
      router.push({ name: 'SolicitudFisica' }).catch(() => {});
    }
  }

  public prepareRemove(id: any): void {
    this.removeIndex = id;
    this.$bvModal.show('removeSolucion');
  }

  public consultaComentario(item): void {
    this.comentario = item.comentarioEstatus;
    this.$bvModal.show('modalComentario');
  }

  private redireccionaEdionRegistro() {
    EntityFactory.guardarReseteoSede(true);
    this.$router.push({
      name: 'EdicionSolicitud',
    });
  }
}
